import React from "react";
import PropTypes from "prop-types";

const SettingsMenu = ({ user, activeSection, scrollToSection }) => {
	const settingsMenu = user.getOrganizationMenu();

	return (
		<div id="settings-menu">
			<For
				each="item"
				of={settingsMenu}
			>
				<If
					condition={
						(item.id !== "subscriptions" && item.id !== "ondutyscheduleintegration") ||
						(item.id === "subscriptions" &&
							user?.Organization?.StripeSubscriptionEnabled) ||
						(item.id === "ondutyscheduleintegration" &&
							user?.Organization?.OnDutyUserScheduleEnabled)
					}
				>
					<button
						key={`settings-btn-${item.id}`}
						type="button"
						className={`btn btn-block text-left${activeSection === item.id ? " active" : ""}`}
						onClick={() => scrollToSection(item.id)}
					>
						<i className={item.icon} />
						{item.title}
					</button>
				</If>
			</For>
		</div>
	);
};

SettingsMenu.propTypes = {
	user: PropTypes.object,
	activeSection: PropTypes.string.isRequired,
	scrollToSection: PropTypes.func.isRequired,
};

SettingsMenu.defaultProps = {
	user: {},
};

export default SettingsMenu;
